import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/images/border-effect.png';
const _hoisted_1 = {
    id: "contact-us",
    class: "contact-us back-dark contact"
};
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "text-center row justify-content-center" };
const _hoisted_4 = { class: "col-md-12 bot-menu" };
const _hoisted_5 = { class: "foot-menu" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"row control-pad\" data-v-fdac64aa><div class=\"border-effect1\" data-v-fdac64aa><img src=\"" + _imports_0 + "\" class=\"img-fluid\" alt=\"effect\" data-v-fdac64aa></div><div class=\"border-effect2\" data-v-fdac64aa><img src=\"" + _imports_0 + "\" class=\"img-fluid\" alt=\"effect\" data-v-fdac64aa></div></div>", 1)),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                                _createVNode(_component_router_link, {
                                    to: "/about",
                                    class: ""
                                }, {
                                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                                        _createTextVNode("About Us")
                                    ])),
                                    _: 1
                                })
                            ]),
                            _createElementVNode("li", null, [
                                _createVNode(_component_router_link, { to: "/contact" }, {
                                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                                        _createTextVNode("Contact")
                                    ])),
                                    _: 1
                                })
                            ]),
                            _cache[3] || (_cache[3] = _createElementVNode("li", null, [
                                _createElementVNode("a", {
                                    href: "/privacy-policy",
                                    class: "active"
                                }, "Privacy Policy")
                            ], -1)),
                            _createElementVNode("li", null, [
                                _createVNode(_component_router_link, { to: "/terms-of-service" }, {
                                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                                        _createTextVNode("Terms of Service")
                                    ])),
                                    _: 1
                                })
                            ])
                        ])
                    ])
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-md-12" }, [
                    _createElementVNode("div", { class: "copy-right" }, [
                        _createElementVNode("h6", null, "© Azurecoinz 2025. All rights reserved.")
                    ])
                ], -1))
            ])
        ])
    ]));
}
